import { BIModel } from './BIModel';

export class ProductViewBIModel extends BIModel {

  static eventName = 'product_view';

  #flow;
  #productId;
  #currentUrl;
  #referrerUrl;
  #isSeller;
  #closetOwner;
  #fairPrice;
  #lastConnection;
  #timeToAnswer;
  #countrySeller;

  constructor(
    userId, 
    flow, 
    productId, 
    currentUrl, 
    referrerUrl, 
    isSeller, 
    closetOwner, 
    fairPrice,
    lastConnection,
    timeToAnswer,
    countrySeller
  ) {
    super(ProductViewBIModel.eventName, userId);
    this.#flow = flow;
    this.#productId = productId;
    this.#currentUrl = currentUrl;
    this.#referrerUrl = referrerUrl;
    this.#isSeller = isSeller;
    this.#closetOwner = closetOwner;
    this.#fairPrice = fairPrice;
    this.#lastConnection = lastConnection;
    this.#timeToAnswer = timeToAnswer;
    this.#countrySeller = countrySeller;
  }

  get flow() {
    return this.#flow;
  }
  
  get productId() {
    return this.#productId;
  }
  
  get currentUrl() {
    return this.#currentUrl;
  }
  
  get referrerUrl() {
    return this.#referrerUrl;
  }
  
  get isSeller() {
    return this.#isSeller;
  }
  
  get closetOwner() {
    return this.#closetOwner;
  }

  get fairPrice() {
    return this.#fairPrice;
  }

  get lastConnection() {
    return this.#lastConnection;
  }

  get timeToAnswer() {
    return this.#timeToAnswer;
  }

  get modelData() {
    return {
      flow: this.#flow,
      product_id: this.#productId,
      current_url: this.#currentUrl,
      referrer_url: this.#referrerUrl,
      is_seller: this.#isSeller,
      closet_owner: this.#closetOwner,
      badge: this.#fairPrice,
      owner_last_connection_h: this.#lastConnection,
      owner_time_to_answer_h: this.#timeToAnswer,
      country_seller: this.#countrySeller
    };
  }
  
}